<template>
  <HeaderTrade />

     <!-- Container Start { -->
     <div id="container" class="sts-trade-container">
       <!-- Contents Start { -->
       <div id="contents">

         <TradeTopNav 
         :pid="route.params.id"
         />

         <!-- content start -->
         <div class="contents-area">

           <div class="chart-info-inner">

             <TopItemInfo v-if="item"
              :selectItem="item"
              :pid="route.params.id"
            /> 

           </div>

           <HTSContainerCF v-if="currentTradeType =='G' && item "
              :selectItem="item"   
              :pid="route.params.id"
           />
            <HTSContainer v-else-if="currentTradeType !='G' && item"
             :selectItem="item" 
             :pid="route.params.id"  
           />


         </div>
         <!-- // content end -->


         <TradeBottomNav 
          :id="route.params.id"
         />

       </div>
       <!-- } Contents End -->

  

     </div>
     <!-- } Container End -->


</template>

<script>
import { useStore } from 'vuex';
import HeaderTrade from '@/components/HeaderTrade.vue';
import TradeTopNav from "@/components/TradeTopNav.vue"
import TradeBottomNav from "@/components/TradeBottomNav.vue"
import { onMounted, ref, computed, onUnmounted } from 'vue'
import {useRoute }from 'vue-router'
import {useGetItemList} from '@/composables/vtradeFn';
import HTSContainer from '@/components/trade/HTSContainer.vue';
import HTSContainerCF from '@/components/trade/coinFutures/HTSContainer_cf.vue';
import TopItemInfo from '@/components/trade/TopItemInfo.vue';
import { useScoket } from '@/socket';

export default {
  components:{   
    HeaderTrade,
    TradeTopNav,
    TradeBottomNav,    
    HTSContainer,
    HTSContainerCF,
    TopItemInfo  
  },
 
  setup(){
    const  {getItemByCode} = useGetItemList()
    const route = useRoute();
    const store = useStore();
    store.commit('trade/CHANGE_CURRENT_PAGE_BOTTOM', 'orderbook'); 
    store.commit('trade/CHANGE_CURRENT_PAGE_ID', 'navi_0');   
    const currentTradeType = computed(() => store.state.hts.currentTradeType);
    //console.log("!!!!orderBook", route.params.code)
    const {socket} = useScoket(); 
    const item = ref(null)


    onMounted(async ()=>{    
        item.value = await getItemByCode(currentTradeType.value, route.params.code) 
        var _isNight = false;
        if(item.value.TYPE == 'F')
        {         
          if(item.value.isNight  && String(item.value.isNight) == 'true') 
          { 
              item.value.CODE = item.value.CODE.split('_')[0];                        
              _isNight = true;           
          }
        }
        //console.log("onMounted item.value", item.value, socket)
        store.commit('hts/CHANGE_CURRENT_ITEM', item.value);
        setTimeout(()=>{
            socket.emit("requestInit", {
                itemType: item.value.TYPE,
                code: item.value.CODE,
                isNight:_isNight        
            }, function() {  
                setTimeout(()=>{
                  socket.emit("requestCode", {
                      itemType:item.value.TYPE,
                      code:item.value.CODE,
                      isNight:_isNight 
                  }, function() { 
                    console.log("requestCode:",  item.value.CODE)    
                  })    
                },500)
            })
        }, 100)


    })


    onUnmounted(()=>{
          socket.emit("leaveCode", {
              itemType:  item.value.TYPE,
              code: item.value.CODE,
              isNight:item.value.isNight?item.value.isNight:false
          }, function() { 
              //  console.log("leaveCode:",  item.CODE)    
          })                
    })






    return {
   

      item,
      currentTradeType,
      route
      
    }
  }
}
</script>

<style>

</style>